export default "/images/img_6.png?6a2a4722ba1c229c005a3986806a6bf0";